import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import Professional from '../../models/Professional'

export default class GuideForm implements FormBase {

    static NewInstance(): GuideForm {
        return new GuideForm();
    }

    ValidateToGoNextStep(): string {
        return "";
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        return Promise.resolve(true);
    }

    GetFieldByName(name: string): FormFieldBase {
        return new FormFieldBase("", []);
    }
}